import gql from 'graphql-tag'
import { ActivationSubmitModule as ParentActivationSubmitModule } from '../submit'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'

const initialState = {
  consents: {},
  result: {},
  processId: null,
  contractDocumentUrl: null
}

const ActivationSubmitModule = {
  namespaced: true,
  state: initialState,
  getters: {
    deferredResponse: ParentActivationSubmitModule.getters.deferredResponse,
    getSuccessIdent: ParentActivationSubmitModule.getters.getSuccessIdent,
    getSuccessUrl: ParentActivationSubmitModule.getters.getSuccessUrl,
    consents: ParentActivationSubmitModule.getters.consents,
    processId: ParentActivationSubmitModule.getters.processId,
    activationInputCore: ParentActivationSubmitModule.getters.activationInputCore,
    contractDocumentUrl: ParentActivationSubmitModule.getters.contractDocumentUrl,
    referFriendInput: (state, getters, rootState, rootGetters) => {
      if (rootGetters['friendNotification/existingCustomerMsisdn']) {
        return {
          referFriend: {
            existingCustomerMsisdn: rootGetters['friendNotification/existingCustomerMsisdn'],
            newCustomerMsisdn: rootGetters['activation/info/msisdn'],
            captcha: rootGetters['friendNotification/captcha']
          }
        }
      } else {
        return null
      }
    }
  },
  mutations: {
    storeResult: ParentActivationSubmitModule.mutations.storeResult,
    storeProcessId: ParentActivationSubmitModule.mutations.storeProcessId,
    storeConsents: ParentActivationSubmitModule.mutations.storeConsents,
    storeContractDocumentUrl: ParentActivationSubmitModule.mutations.storeContractDocumentUrl
  },
  actions: {
    async activationInitiate ({ commit, state, getters, rootGetters }, { nextStep = 'summary' }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`
          mutation activation ($activationInput: ActivationInput!) {
            activationInitiate (activationInput: $activationInput){
              contractDocumentUrl
              processId
            }
          }`,
        variables: {
          activationInput: {
            ...getters.activationInputCore,
            topup: {
              ...rootGetters['activation/topUp/topUpCore'],
              singleTopupAmount: rootGetters['activation/topUp/singleTopUpCore']
            },
            product: {
              tariffIdentifier: rootGetters['activation/tariff/tariffId'],
              promotions: null,
              tariffotions: rootGetters['activation/tariffOptions/tariffOptionIds'],
              article: null,
              simType: rootGetters['activation/personalData/simType']
            },
            ...getters.referFriendInput,
            orderContext: {
              market: rootGetters['activation/info/market'],
              orderByAgent: rootGetters['activation/info/orderByAgent']
            }
          }
        }
      }).then((response) => {
        commit('storeProcessId', response.data.activationInitiate.processId)
        commit('storeContractDocumentUrl', response.data.activationInitiate.contractDocumentUrl)
        commit('activation/goToStep', nextStep, { root: true })
        return response.data.activationInitiate.contractDocumentUrl
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async activationConfirm ({ commit, state, getters, rootGetters }, { nextStep = 'success', consents }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`
          mutation activation ($activationConfirmInput: ActivationConfirmInput!) {
            activationConfirm (activationConfirm: $activationConfirmInput){
              contractId,
              customerId,
              deferredIdentificationResponse {
                actionID,
                identProvider,
                url
              }
            }
          }`,
        variables: {
          activationConfirmInput: {
            brand: rootGetters.brand,
            msisdn: rootGetters['activation/info/msisdn'],
            processId: getters.processId,
            consent: {
              adConsent: consents.contact,
              passData: consents.exchange,
              agb: consents.agb,
              contractTermsVersion: consents.contractTermsVersion
            }
          }
        }
      }).then((response) => {
        commit('storeConsents', consents)
        commit('storeResult', response.data.activationConfirm)
        commit('Transaction/removeTransactionId', 'activation', { root: true })
        commit('activation/goToStep', nextStep, { root: true })
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  }
}

export {
  ActivationSubmitModule
}
